export function getAnonymousId(): string {
    let id = localStorage.getItem('anonymous_id')

    if (!id) {
        if (crypto?.randomUUID) {
            id = crypto.randomUUID()
        } else {
            id = `${Date.now()}-${Math.random().toString(36).substring(2)}`
        }

        localStorage.setItem('anonymous_id', id)
    }

    return id
}
